import React from 'react';

import { Box } from '@mui/joy';

import Dock from './Dock';

interface CrewViewDockProps {
  agl: string;
  asl: string;
  airSpeed: string;
  groundSpeed: string;
  time: string;
  remainingTime: string;
  homeDistance: string;
}

const CrewViewDock: React.FC<CrewViewDockProps> = ({
  agl,
  asl,
  airSpeed,
  groundSpeed,
  time,
  remainingTime,
  homeDistance
}) => {
  return (
    <Box
      className='w-full z-20 absolute bottom-0 sm:bottom-1.5 flex justify-center items-center transition-all duration-300 left-0 right-0'
      sx={{
        // Mobile landscape: adjust based on screen width
        '@media (orientation: landscape) and (min-width: 910px) and (max-width: 1024px)': {
          bottom: '0px',
          padding: '0px',
          width: '100%',
          left: '0',
          right: '0',
          fontSize: '95%',
          '& .MuiTypography-root': {
            fontSize: 'inherit'
          }
        },
        '@media (orientation: landscape) and (max-width: 909px)': {
          bottom: '0px',
          padding: '0px',
          width: '100%',
          left: '0',
          right: '0',
          fontSize: '76.6%',
          '& .MuiTypography-root': {
            fontSize: 'inherit'
          }
        }
      }}
    >
      <Dock
        agl={agl}
        asl={asl}
        airSpeed={airSpeed}
        groundSpeed={groundSpeed}
        time={time}
        remainingTime={remainingTime}
        homeDistance={homeDistance}
      />
    </Box>
  );
};

export default CrewViewDock;
